<template>
  <div id="tabelaGabarito">
    <a ref="dwld" class="d-none print-hide" :href="downloadLink" download></a>
    <template
      v-if="
        (lstTesteGabarito.length > 0 && prova == 'SIM') ||
        (lstTesteGabarito.length > 0 && gabarito == 'SIM')
      "
    >
      <b-row v-for="(item, index) in lstTesteGabarito" :key="index" class="my-3">
        <b-col cols="12" class="mt-4 mb-3">
          <div class="instituicaoGabarito">
            <div class="font-weight-bold">{{ instituicao }}</div>
            <div class="text-primary text-h6">{{ concurso }}</div>
            <hr />
          </div>
          <div class="font-weight-bold text-subtitle1">
            {{ `${item.lista[index].titulo} - ${item.lista[index].provas}` }}
          </div>
          <div>Cargo: {{ cargo }}. Tipo de Gabarito: {{ item.lista[index].tipogabarito }}</div>
          <div v-if="gabarito == 'SIM'" class="dataGabarito">
            Data de Públicação de Gabarito: {{ item.lista[index].dtinigabaritoacesso }}
          </div>
        </b-col>
        <b-col cols="12" class="mb-2 print-hide">
          <fcc-button
            v-if="index == 0 && gabarito == 'SIM'"
            color="outline-primary"
            @click="imprimir('tabelaGabarito')"
            icon="print"
            class="mr-2"
          >
            Imprimir Gabarito
          </fcc-button>
          <template v-if="prova == 'SIM'">
            <fcc-button
              color="outline-primary"
              @click="abrirGabarito(item, index)"
              icon="expand-arrows-alt"
              class="mr-2"
            >
              Expandir Prova
            </fcc-button>
            <fcc-button
              color="outline-primary"
              class="mr-2"
              @click="visualizarArquivoProva(item, index)"
              :icon="item.verProva ? 'eye-slash' : 'eye'"
            >
              {{ item.verProva ? 'Fechar' : 'Visualizar' }} Prova
            </fcc-button>
            <fcc-button
              v-if="downloadprova"
              color="outline-primary"
              @click="downloadArquivo(item)"
              icon="download"
            >
              Download
            </fcc-button>
          </template>
        </b-col>
        <b-col v-if="gabarito == 'SIM'" cols="12" :sm="item.verProva ? '6' : '12'">
          <div class="overflow-auto tabelaGabarito">
            <fcc-table
              :porPage="item.lista.length.toString()"
              striped
              hover
              :fields="fieldsTeste"
              totalRegistros="Total de questões:"
              :items="item.lista"
              responsive
            >
              <template #gabaritoatual="{ row, value }">
                <p :class="row.alteracao != 0 ? 'text-h6 font-weight-bold' : ''">{{ value }}</p>
              </template>
            </fcc-table>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="print-hide"
          :sm="item.verProva && gabarito == 'SIM' ? '6' : '12'"
          v-if="item.verProva && arquivoProva"
        >
          <fcc-visualizador-pdf :arquivo="arquivoProva" />
        </b-col>
      </b-row>
    </template>
    <div v-else>Nenhum resultado encontrado.</div>
    <fcc-modal
      idModal="gabaritoProva"
      :titleModal="tituloModal"
      size="lg"
      centered
      escondeFooter
      travaEsc
      travaBack
    >
      <b-row v-if="arquivoProva">
        <b-col cols="12" v-if="downloadprova">
          <fcc-button
            color="outline-primary"
            @click="downloadArquivo(lstTesteGabarito[indexProva])"
            icon="download"
            class="mb-2"
          >
            Download
          </fcc-button>
        </b-col>
        <b-col cols="12">
          <fcc-visualizador-pdf :arquivo="arquivoProva" />
        </b-col>
      </b-row>
    </fcc-modal>
  </div>
</template>
<script>
import fccVisualizadorPdf from './fccVisualizadorPDF.vue'

export default {
  data() {
    return {
      verProva: {},
      tituloModal: '',
      modal: true,
      arquivoProva: '',
      rotacionarx: 0,
      indexProva: '',
      downloadLink: '',
      fieldsTeste: [
        {
          key: 'questao',
          label: 'Questão',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'gabaritoatual',
          label: 'Resposta',
          sortable: true,
          tdClass: 'text-center',
          thClass: 'text-center',
          type: 'slot'
        },
        {
          key: 'descricao',
          label: 'Situação',
          sortable: true
        }
      ]
    }
  },
  components: {
    fccVisualizadorPdf
  },
  props: {
    lstTesteGabarito: {
      type: Array,
      default: () => []
    },
    idNotificacao: {
      type: String,
      default: ''
    },
    gabarito: {
      type: String,
      default: ''
    },
    prova: {
      type: String,
      default: ''
    }
  },
  computed: {
    cargo() {
      let codCargo = this.lstTesteGabarito[0].lista[0].apcodopcao
        ? `${this.lstTesteGabarito[0].lista[0].codcargo} - `
        : ''
      return `${codCargo}${this.lstTesteGabarito[0].lista[0].cargo}`
    },
    downloadprova() {
      return this.lstTesteGabarito[0].lista[0].downloadprova
    },
    concurso() {
      return this.lstTesteGabarito[0].lista[0].concurso
    },
    instituicao() {
      return this.lstTesteGabarito[0].lista[0].instituicao
    }
  },
  watch: {
    lstTesteGabarito() {
      this.lstTesteGabarito = this.lstTesteGabarito
      this.arquivoProva = ''
    }
  },
  methods: {
    downloadArquivo(item) {
      this.downloadArquivoGenerico(item.lista[0].idsga).then((response) => {
        this.$refs.dwld.href = window.URL.createObjectURL(new Blob([response.data]))
        this.$refs.dwld.setAttribute('download', item.lista[0].arquivoprova)
        this.$refs.dwld.click()
        this.callToast('Download realizado com sucesso', 'positive')
        this.carregaTexto()
      })
    },
    visualizarArquivoProva(item) {
      item.verProva = !item.verProva
      this.$forceUpdate()
      if (item.verProva) {
        this.downloadArquivoGabarito(item)
      }
    },
    downloadArquivoGabarito(item) {
      this.carregaTexto(this.codeMensagem('C01'))
      this.baixardownloadGoogleTempPublic(item.lista[0].idsga).then((response) => {
        this.arquivoProva = response.data.arqchaverepositorio
        this.carregaTexto()
        this.$forceUpdate()
      })
    },
    abrirGabarito(item, index) {
      this.indexProva = index
      this.tituloModal = `${item.lista[0].titulo} - ${item.lista[0].provas}`
      this.downloadArquivoGabarito(item)
      this.$root.$emit('bv::show::modal', 'gabaritoProva')
    },
    imprimir(elemento) {
      const el = document.getElementById(elemento)?.innerHTML
      if (el != null) {
        var a = window.open('', '', 'height=500, width=500')
        a?.document.write('<html>')
        a?.document.write(
          '<link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet">'
        )
        a?.document.write(
          '<style>body{ font-family: Roboto } .text-weight-bold{font-weight: bold;} .text-primary{color: #a90637;} .instituicaoGabarito { page-break-before: always;  }   .dataGabarito { font-size: 12px;} .tabelaGabarito { max-height: auto;} .print-hide {display: none; }.text-subtitle2{font-size: 10px;} .text-subtitle1 { font-size: 14px; font-weight: bold; padding-top: 10px; padding-bottom: 10px;} .sr-only, .clone{display:none;}.col-12, .table{width: 100%; page-break-inside: revert-layer !important;} .text-center{text-align: left;} th{background: #ccc; text-align: left;} td{padding: 10px;} th, td, tr{border: 1px solid #000; border-spacing: 0px;}</style>'
        )
        a?.document.write('<body>')
        a?.document.write(el)
        a?.document.write('</body></html>')
        a?.print()
        a?.window.close()
      }
    }
  }
}
</script>
<style scoped>
.tabelaGabarito {
  max-height: 600px;
}
</style>
